var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M245.76,78.78V22.76c0-3.13-2.54-5.67-5.67-5.67 H89.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M245.76,78.78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M245.76,129.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M35.1,75v183.38c0,3.13,2.54,5.67,5.67,5.67 h199.32c3.13,0,5.67-2.54,5.67-5.67V129.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M37.27,66.79l46.86-47.51 c4.64-4.7,12.57-1.37,12.57,5.28v47.51c0,4.12-3.3,7.46-7.36,7.46H42.48C35.92,79.53,32.64,71.49,37.27,66.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M140.42,210.86l41.76-18.16l82.33-82.33 l-25.46-25.46l-82.67,82.67L138.55,209C138.05,210.18,139.24,211.37,140.42,210.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M243.08,80.89c6.29-6.29,17.09-5.69,24.12,1.34 c7.03,7.03,7.63,17.83,1.33,24.12"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 226.76,
    y1: 97.21,
    x2: 252.22,
    y2: 122.67
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 179.63,
    y1: 189.15,
    x2: 153.73,
    y2: 163.25
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 142.35,
    y1: 194.79,
    x2: 154.63,
    y2: 207.08
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 138.43,
    y1: 210.98,
    x2: 62.49,
    y2: 210.98
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 134.49,
    y1: 169.52,
    x2: 62.49,
    y2: 169.52
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 166.68,
    y1: 130.74,
    x2: 62.49,
    y2: 130.74
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 204.45,
    y1: 92.22,
    x2: 117.63,
    y2: 92.22
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 221.82,
    y1: 53.7,
    x2: 117.63,
    y2: 53.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/Description.de984b7bcf30b6722ee24a8f5c05fb74.svg";
export { ForwardRef as ReactComponent };